import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import Gabriel from '../Imagenes/Equipo/Gabriel.png';
import Juan from '../Imagenes/Equipo/Juan.png';
import Gustavo from '../Imagenes/Equipo/Gustavo.png';
import { FaLinkedin } from 'react-icons/fa';
import AbstractBackground from "../components/AbstractBackground";
const Team = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.2
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);
  const equipo = [{
    nombre: "Gabriel Albarracin",
    rol: "Project Leader",
    imagen: Gabriel,
    linkedin: "https://www.linkedin.com/in/gabriel-albarracin-b384101bb/"
  }, {
    nombre: "Gustavo Albarracin",
    rol: "FullStack Developer",
    imagen: Gustavo,
    linkedin: "https://www.linkedin.com/in/gustavo-albarracín/"
  }, {
    nombre: "Juan Mateo Viscovich",
    rol: "FullStack Developer",
    imagen: Juan,
    linkedin: "https://www.linkedin.com/in/juan-mateo-viscovich/"
  }];
  return <div id="equipo" ref={sectionRef} className="relative bg-gradient-to-b from-[#0e0f11] via-[#101214] to-[#0e0f11] pt-32 pb-40 overflow-hidden">
            {/* Línea decorativa superior */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#bdff57]/30 to-transparent" />

            {/* Fondo tipo Portafolio: puntos + glows */}
            <AbstractBackground variant="dots" />

            <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
                {/* Header */}
                <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        ease: "easeOut"
      }} className="text-center mb-20">
                    <span className="inline-block px-4 py-1.5 mb-6 text-sm font-medium text-[#bdff57] border border-[#bdff57]/30 rounded-full bg-[#bdff57]/5">
                        Quiénes somos
                    </span>
                    <h2 className="text-4xl sm:text-6xl lg:text-7xl font-normal tracking-tight text-white">
                        El equipo de <span className="text-[#bdff57]">trabajo</span>
                    </h2>
                    <p className="mt-6 text-lg text-gray-400 max-w-2xl mx-auto">
                        Profesionales apasionados por la tecnología y comprometidos con tu éxito
                    </p>
                </motion.div>

                {/* Grid del equipo */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-20 md:gap-8 lg:gap-12">
                    {equipo.map((miembro, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} animate={isVisible ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          ease: "easeOut",
          delay: 0.2 + index * 0.15
        }} className="group">
                            <div className="relative">
                                {/* Card principal */}
                                <div className="relative p-6 rounded-2xl bg-gradient-to-br from-[#1a1b1e]/80 to-[#141517]/80 border border-white/5 hover:border-[#bdff57]/20 transition-all duration-500">
                                    {/* Imagen circular */}
                                    <div className="relative -mt-20 mb-6 flex justify-center">
                                        <div className="relative">
                                            {/* Anillo decorativo */}
                                            <div className="absolute inset-0 rounded-full bg-gradient-to-br from-[#bdff57]/30 to-transparent p-1 opacity-0 group-hover:opacity-100 transition-opacity duration-500 scale-110" />

                                            <div className="relative w-32 h-32 sm:w-40 sm:h-40 rounded-full overflow-hidden border-4 border-[#0e0f11] bg-[#0e0f11]">
                                                <img src={miembro.imagen} alt={miembro.nombre} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                                            </div>

                                            {/* Botón de LinkedIn */}
                                            <a href={miembro.linkedin} target="_blank" rel="noopener noreferrer" className="absolute -bottom-2 -right-2 w-10 h-10 rounded-xl bg-[#0e0f11] border border-white/10 flex items-center justify-center group-hover:bg-[#bdff57] group-hover:border-[#bdff57] transition-all duration-300">
                                                <FaLinkedin className="w-5 h-5 text-gray-400 group-hover:text-black transition-colors" />
                                            </a>
                                        </div>
                                    </div>

                                    {/* Info */}
                                    <div className="text-center">
                                        <h3 className="text-xl font-semibold text-white group-hover:text-[#bdff57] transition-colors duration-300">
                                            {miembro.nombre}
                                        </h3>
                                        <p className="text-[#bdff57] text-sm font-medium mt-1">
                                            {miembro.rol}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </motion.div>)}
                </div>
            </div>
        </div>;
};
export default Team;